export const config = {
  calendars: {
    main: {
      colorName: "main",
      lightColors: {
        main: "#f9d71c",
        container: "#fff5aa",
        onContainer: "#594800",
      },
      darkColors: {
        main: "#fff5c0",
        onContainer: "#fff5de",
        container: "#a29742",
      },
    },
  },
};
